import { CalendarIcon } from '@hedepy/icons/refactor/Calendar'
import type { MonthCaptionProps } from 'react-day-picker'

import { cn } from '@/legacy-src/lib/utils'

import { Text } from '@/src/domains/design-system/components/Text'

export type ClientBookingMonthCalendarCaptionProps = MonthCaptionProps

export const ClientBookingMonthCalendarCaption = ({
  calendarMonth,
  displayIndex,
  className,
  children,
  ...props
}: ClientBookingMonthCalendarCaptionProps) => (
  <div {...props} className={cn('flex h-8 items-center justify-center gap-2', className)}>
    <CalendarIcon aria-hidden size={30} className="mr-2 text-primary" />
    <Text element="span" weight="bold" family="serif">
      {children}
    </Text>
  </div>
)
